module.exports = __webpack_public_path__ + "img/solution-securityTest-function-icon-1.f33e3860.svg";